var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 150C122.421 150 156 116.421 156 75C156 33.5786 122.421 0 81 0C39.5786 0 6 33.5786 6 75C6 116.421 39.5786 150 81 150Z",
    fill: "#E6FFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6723_40155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 54H189C190.326 54 191.598 54.5268 192.536 55.4645C193.473 56.4021 194 57.6739 194 59V84C194 85.3261 193.473 86.5979 192.536 87.5355C191.598 88.4732 190.326 89 189 89H54C52.6739 89 51.4021 88.4732 50.4645 87.5355C49.5268 86.5979 49 85.3261 49 84V59C49 57.6739 49.5268 56.4021 50.4645 55.4645C51.4021 54.5268 52.6739 54 54 54V54Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 62H102C100.343 62 99 63.3431 99 65C99 66.6569 100.343 68 102 68H128C129.657 68 131 66.6569 131 65C131 63.3431 129.657 62 128 62Z",
    fill: "#BDE4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 75H102C100.343 75 99 76.3431 99 78C99 79.6569 100.343 81 102 81H146C147.657 81 149 79.6569 149 78C149 76.3431 147.657 75 146 75Z",
    fill: "#D3F3EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 81C84.7467 81 89 76.7467 89 71.5C89 66.2533 84.7467 62 79.5 62C74.2533 62 70 66.2533 70 71.5C70 76.7467 74.2533 81 79.5 81Z",
    fill: "#1177BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.194 70.08C80.4973 70.08 80.768 70.143 81.006 70.269C81.2487 70.395 81.4377 70.5817 81.573 70.829C81.713 71.0763 81.783 71.375 81.783 71.725V74H80.992V71.844C80.992 71.4987 80.9057 71.235 80.733 71.053C80.5603 70.8663 80.3247 70.773 80.026 70.773C79.7273 70.773 79.4893 70.8663 79.312 71.053C79.1393 71.235 79.053 71.4987 79.053 71.844V74H78.262V71.844C78.262 71.4987 78.1757 71.235 78.003 71.053C77.8303 70.8663 77.5947 70.773 77.296 70.773C76.9973 70.773 76.7593 70.8663 76.582 71.053C76.4093 71.235 76.323 71.4987 76.323 71.844V74H75.525V70.143H76.323V70.584C76.4537 70.4253 76.6193 70.3017 76.82 70.213C77.0207 70.1243 77.2353 70.08 77.464 70.08C77.772 70.08 78.0473 70.1453 78.29 70.276C78.5327 70.4067 78.7193 70.5957 78.85 70.843C78.9667 70.6097 79.1487 70.4253 79.396 70.29C79.6433 70.15 79.9093 70.08 80.194 70.08ZM83.7294 70.794V72.929C83.7294 73.0737 83.7621 73.1787 83.8274 73.244C83.8974 73.3047 84.0141 73.335 84.1774 73.335H84.6674V74H84.0374C83.6781 74 83.4028 73.916 83.2114 73.748C83.0201 73.58 82.9244 73.307 82.9244 72.929V70.794H82.4694V70.143H82.9244V69.184H83.7294V70.143H84.6674V70.794H83.7294Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6723_40155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 97H146C147.326 97 148.598 97.5268 149.536 98.4645C150.473 99.4021 151 100.674 151 102V127C151 128.326 150.473 129.598 149.536 130.536C148.598 131.473 147.326 132 146 132H11C9.67392 132 8.40215 131.473 7.46447 130.536C6.52678 129.598 6 128.326 6 127V102C6 100.674 6.52678 99.4021 7.46447 98.4645C8.40215 97.5268 9.67392 97 11 97V97Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105H59C57.3431 105 56 106.343 56 108C56 109.657 57.3431 111 59 111H85C86.6569 111 88 109.657 88 108C88 106.343 86.6569 105 85 105Z",
    fill: "#BDE4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103 118H59C57.3431 118 56 119.343 56 121C56 122.657 57.3431 124 59 124H103C104.657 124 106 122.657 106 121C106 119.343 104.657 118 103 118Z",
    fill: "#D3F3EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 124C28.7467 124 33 119.747 33 114.5C33 109.253 28.7467 105 23.5 105C18.2533 105 14 109.253 14 114.5C14 119.747 18.2533 124 23.5 124Z",
    fill: "#1177BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.194 113.08C24.4973 113.08 24.768 113.143 25.006 113.269C25.2487 113.395 25.4377 113.582 25.573 113.829C25.713 114.076 25.783 114.375 25.783 114.725V117H24.992V114.844C24.992 114.499 24.9057 114.235 24.733 114.053C24.5603 113.866 24.3247 113.773 24.026 113.773C23.7273 113.773 23.4893 113.866 23.312 114.053C23.1393 114.235 23.053 114.499 23.053 114.844V117H22.262V114.844C22.262 114.499 22.1757 114.235 22.003 114.053C21.8303 113.866 21.5947 113.773 21.296 113.773C20.9973 113.773 20.7593 113.866 20.582 114.053C20.4093 114.235 20.323 114.499 20.323 114.844V117H19.525V113.143H20.323V113.584C20.4537 113.425 20.6193 113.302 20.82 113.213C21.0207 113.124 21.2353 113.08 21.464 113.08C21.772 113.08 22.0473 113.145 22.29 113.276C22.5327 113.407 22.7193 113.596 22.85 113.843C22.9667 113.61 23.1487 113.425 23.396 113.29C23.6433 113.15 23.9093 113.08 24.194 113.08ZM27.7294 113.794V115.929C27.7294 116.074 27.7621 116.179 27.8274 116.244C27.8974 116.305 28.0141 116.335 28.1774 116.335H28.6674V117H28.0374C27.6781 117 27.4028 116.916 27.2114 116.748C27.0201 116.58 26.9244 116.307 26.9244 115.929V113.794H26.4694V113.143H26.9244V112.184H27.7294V113.143H28.6674V113.794H27.7294Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6723_40155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 11H11C8.23858 11 6 13.2386 6 16V41C6 43.7614 8.23858 46 11 46H146C148.761 46 151 43.7614 151 41V16C151 13.2386 148.761 11 146 11Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19H57C55.3431 19 54 20.3431 54 22C54 23.6569 55.3431 25 57 25H83C84.6569 25 86 23.6569 86 22C86 20.3431 84.6569 19 83 19Z",
    fill: "#BDE4FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101 32H57C55.3431 32 54 33.3431 54 35C54 36.6569 55.3431 38 57 38H101C102.657 38 104 36.6569 104 35C104 33.3431 102.657 32 101 32Z",
    fill: "#D3F3EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 38C41.7467 38 46 33.7467 46 28.5C46 23.2533 41.7467 19 36.5 19C31.2533 19 27 23.2533 27 28.5C27 33.7467 31.2533 38 36.5 38Z",
    fill: "#1177BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.255 27.08C36.5584 27.08 36.829 27.143 37.067 27.269C37.3097 27.395 37.4987 27.5817 37.634 27.829C37.774 28.0763 37.844 28.375 37.844 28.725V31H37.053V28.844C37.053 28.4987 36.9667 28.235 36.794 28.053C36.6214 27.8663 36.3857 27.773 36.087 27.773C35.7884 27.773 35.5504 27.8663 35.373 28.053C35.2004 28.235 35.114 28.4987 35.114 28.844V31H34.323V28.844C34.323 28.4987 34.2367 28.235 34.064 28.053C33.8914 27.8663 33.6557 27.773 33.357 27.773C33.0584 27.773 32.8204 27.8663 32.643 28.053C32.4704 28.235 32.384 28.4987 32.384 28.844V31H31.586V27.143H32.384V27.584C32.5147 27.4253 32.6804 27.3017 32.881 27.213C33.0817 27.1243 33.2964 27.08 33.525 27.08C33.833 27.08 34.1084 27.1453 34.351 27.276C34.5937 27.4067 34.7804 27.5957 34.911 27.843C35.0277 27.6097 35.2097 27.4253 35.457 27.29C35.7044 27.15 35.9704 27.08 36.255 27.08ZM39.7905 27.794V29.929C39.7905 30.0737 39.8231 30.1787 39.8885 30.244C39.9585 30.3047 40.0751 30.335 40.2385 30.335H40.7285V31H40.0985C39.7391 31 39.4638 30.916 39.2725 30.748C39.0811 30.58 38.9855 30.307 38.9855 29.929V27.794H38.5305V27.143H38.9855V26.184H39.7905V27.143H40.7285V27.794H39.7905Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6723_40155",
    x: 43,
    y: 51,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6723_40155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6723_40155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6723_40155",
    x: 0,
    y: 94,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6723_40155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6723_40155",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6723_40155",
    x: 0,
    y: 8,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6723_40155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6723_40155",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.bedcfb7e3629c6d7df709a8e0733677e.svg";
export { ForwardRef as ReactComponent };